import {csrf} from "~/lib/tools";

const createInspection = async (org_id, payload) => {
    return await fetch(
        `/dashboard/organizations/${org_id}/inspections.json`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            },
            body: JSON.stringify(payload),
        })
        .then(async r => {
            let json = await r.json();
            console.log("createInspection", json);
            console.log("createInspection", json);
            console.log("createInspection", json);
            return {
                ok: r.ok,
                status: r.status,
                data: json.data,
                error: r.statusText,
                errors: json.errors
            }
        });
}
export {createInspection}